$(() => {
  const seasonStatusLabelHandler = () => {
    $(".js-season-status-label").each(function renderLabel() {
      const $label = $(this)
      const id = $label.data("id")
      const template = $(`.season-${seasonStatus[id]}`).html() || ""
      $label.html(template)
    })
  }

  seasonStatusLabelHandler()
  $(".place-info-i").on("details:open", seasonStatusLabelHandler)
})
